import * as cardConsolidation from '../services/cardConsolidation';

export default {
  namespace: 'cardConsolidation',

  state: {
    isMergeSuccess: null,
  },

  effects: {
    *handleMergeCard({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cardConsolidation.handleMergeCard, values);
      yield put({
        type: 'save',
        payload: {
          isMergeSuccess: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
